import React from 'react'

import { Verified } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { elementType, node, string } from 'prop-types'

// The subscription benefits use the filled teal Verified check; the trial note overrides the icon
// with the AI sparkle (see the "No credit card required" row), so the icon is configurable.
function Benefit({ icon: BenefitIcon = Verified, iconClassName = 'ai-sub-landing__benefit-icon', children }) {
  return (
    <li className="ai-sub-landing__benefit">
      <BenefitIcon className={iconClassName} width="20" height="20" aria-hidden="true" />
      <span className="ai-sub-landing__benefit-text cgt-body-md">{children}</span>
    </li>
  )
}

Benefit.propTypes = {
  icon: elementType,
  iconClassName: string,
  children: node.isRequired,
}

export default Benefit
